var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('ul',{staticClass:"new-list"},_vm._l((_vm.noticeList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.go(item)}}},[(index<_vm.numAdd)?_c('p',{staticClass:"li"},[_vm._v(_vm._s(item.title))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }